import React from "react";
import { Form } from "react-bootstrap";

export default function FeedbackSection({
  questions = [],
  // null = parent has not edited yet (render checks from previouslySelectedOptions);
  // [] = parent has edited and cleared all options.
  selectedOptions = null,
  previouslySelectedOptions = [],
  onSelect,
  note,
  previousNote,
  onNoteChange,
  children,
  isValidationError = false,
}) {
  // This component is a placeholder for the Feedback section.
  // It currently does not implement any specific functionality or state management.

  if (!questions.length) {
    return <p>No feedback available for this assessment.</p>;
  }

  const isQuestionAnswered = false; // Placeholder for question answered state

  const handleSelect = (option, isSingle) => {
    // On the first edit, seed the working set from ALL previously-saved
    // selections so multi-select questions don't lose their other answers
    // when the user toggles one more option. Use `=== null` (not
    // `length === 0`) so that an empty working set the user explicitly
    // cleared mid-edit does NOT re-seed.
    const working =
      selectedOptions === null
        ? questions
            .map((q) => q.options)
            .flat()
            .filter(
              (opt) =>
                previouslySelectedOptions.findIndex((o) => o.id === opt.id) !==
                -1
            )
        : selectedOptions;

    if (isSingle) {
      const filtered = working.filter(
        (opt) => opt.parent_id !== option.parent_id
      );
      onSelect([...filtered, option]);
      return;
    }

    const isAlreadySelected = working.some((opt) => opt.id === option.id);
    onSelect(
      isAlreadySelected
        ? working.filter((opt) => opt.id !== option.id)
        : [...working, option]
    );
  };

  return (
    <div className="box_test">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h3 className="test-title-block mb-0">Feedback</h3>
      </div>

      <div
        className={`question-block ${
          isQuestionAnswered ? "question-answered" : ""
        }`}
      >
        {questions.map((question) => {
          const isSingle = question.question_type === "single";
          const inputType = isSingle ? "radio" : "checkbox";
          return (
            <React.Fragment key={question.id}>
              <div className="m-3">
                <div className="d-flex align-items-center justify-content-between">
                  <h5 className="mb-0">{question.option}</h5>
                </div>
              </div>

              {question.options.map((option) => (
                <Form.Group
                  key={option.id}
                  className="form-group checkbox_custom"
                >
                  <Form.Control
                    type={inputType}
                    id={`${question.id}-${option.id}`}
                    name={isSingle ? `option-group-${question.id}` : undefined}
                    checked={
                      selectedOptions === null
                        ? previouslySelectedOptions.findIndex(
                            (opt) => opt.id === option.id
                          ) !== -1
                        : selectedOptions.some((opt) => opt.id === option.id)
                    }
                    onChange={() => {
                      handleSelect(option, isSingle);
                    }}
                  />
                  <Form.Label htmlFor={`${question.id}-${option.id}`}>
                    {option.option}
                  </Form.Label>
                </Form.Group>
              ))}
            </React.Fragment>
          );
        })}

        <Form.Text className="text-danger mt-2" hidden={!isValidationError}>
          Please answer all questions before continuing
        </Form.Text>

        <textarea
          className={`form-control text-left p-3 note-textbox ${
            note ? "border-success" : ""
          }`}
          onChange={onNoteChange}
          value={note || previousNote}
          rows="5"
          maxLength="500"
          name="note"
          placeholder="Notes"
        />
        {note && note.length > 450 && (
          <Form.Text className="text-warning">
            Approaching character limit
          </Form.Text>
        )}

        <div className="mt-3">{children}</div>
      </div>
    </div>
  );
}
